import React from "react";

function Blog() {
  return (
    <div>
      <h1>This is the blog page</h1>
    </div>
  );
}

export default Blog;
